"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListComplexExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/list/examples/complex.ts';
var data = [
    'List item 1',
    'List item 2',
    'List item 3',
    'List item 4'
];
var ListComplexExample = /** @class */ (function () {
    function ListComplexExample() {
    }
    ListComplexExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.List, data.map(function (item) { return (0, mithril_1.default)(_1.ListItem, {
                contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.LINK }),
                contentRight: (0, mithril_1.default)(_1.PopoverMenu, {
                    closeOnContentClick: true,
                    content: [
                        (0, mithril_1.default)(_1.MenuItem, {
                            iconLeft: _1.Icons.EDIT,
                            label: 'Edit'
                        }),
                        (0, mithril_1.default)(_1.MenuItem, {
                            iconLeft: _1.Icons.TRASH_2,
                            label: 'Delete',
                            intent: 'negative'
                        })
                    ],
                    trigger: (0, mithril_1.default)(_1.Button, {
                        iconLeft: _1.Icons.MORE_HORIZONTAL,
                        size: 'xs'
                    }),
                    position: 'bottom-end'
                }),
                label: item
            }); }))
        ]);
    };
    return ListComplexExample;
}());
exports.ListComplexExample = ListComplexExample;
